import { FC } from 'react';

import { getAuctionEditUrl } from 'utils/auction';
import { CampaignProductType } from 'utils/constants/campaign';

import { Alert, Button, ButtonStack } from '@hh.ru/magritte-ui';
import { InfoCircleFilledSize24 } from '@hh.ru/magritte-ui/icon';
import { Link as SPALink } from '@hh.ru/redux-spa-middleware';

import useTrls from 'hooks/translation/useTrls';

import { setInactiveDueToEndDateAlert } from 'store/models/campaignsDashboard';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'CampaignInactiveDueToEndDateAlert.title',
    edit: 'CampaignInactiveDueToEndDateAlert.button.edit',
    cancel: 'CampaignInactiveDueToEndDateAlert.button.cancel',
};

export const CampaignInactiveDueToEndDateAlert: FC = () => {
    const statusChangeCampaignId = useSelector((state) => state.campaignsDashboard.statusChangeCampaignId);
    const isAlertVisible = useSelector((state) => state.campaignsDashboard.isInactiveDueToEndDateAlertVisible);
    const campaign = useSelector((state) =>
        statusChangeCampaignId ? state.campaignsDashboard.campaigns.get(statusChangeCampaignId) : undefined
    );

    const dispatch = useDispatch();
    const trls = useTrls();

    const handleClose = () => dispatch(setInactiveDueToEndDateAlert({ isVisible: false, campaignId: null }));

    const editLink =
        campaign?.productType === CampaignProductType.SearchAuction
            ? getAuctionEditUrl(campaign.vacancyId)
            : `/new/campaign/${statusChangeCampaignId ?? ''}`;

    return (
        <Alert
            visible={isAlertVisible}
            title={trls(TrlKeys.title)}
            buttons={
                <ButtonStack stretched layout="vertical">
                    <Button
                        mode="primary"
                        style="accent"
                        size="small"
                        Element={SPALink}
                        to={editLink}
                        onClick={handleClose}
                        data-qa={`alert-campaign-inactive-due-to-end-date-edit`}
                    >
                        {trls(TrlKeys.edit)}
                    </Button>
                    <Button mode="secondary" style="accent" onClick={handleClose}>
                        {trls(TrlKeys.cancel)}
                    </Button>
                </ButtonStack>
            }
            onClose={handleClose}
        >
            <InfoCircleFilledSize24
                initialColor="tertiary"
                backgroundStyle="secondary"
                padding={12}
                borderRadius="halfHeight"
            />
        </Alert>
    );
};
